export const TOOLTIP_TRANSITION_MS = 100;
export const TOOLTIP_DELAY_MS = 500;
